<script setup>
import { ref, reactive, onMounted } from 'vue';
import { ElMessage, ElLoading } from 'element-plus';
import request from '@/utils/request';
import { useRouter } from 'vue-router';
import { getReviewTaskList, getReviewWorkList, getActivityListApi, getDictList, getReviewRecordsApi } from '@/utils/api';

const revirwer_type = JSON.parse(localStorage.getItem('user')).reviewer_type;
// 状态管理
const pendingProjects = ref([
  // {
  //   id: 1,
  //   projectName: '项目1',
  //   author: '作者1',
  //   description: '这是一个项目',
  //   category: '分类1',
  //   submitTime: '2023-01-01',
  //   group: '组1',
  //   isPhysicalObject: '非实物',
  //   status: '待评审'
  // },
  // {
  //   id: 1,
  //   projectName: '项目2',
  //   author: '作者2',
  //   description: '这是一个项目',
  //   category: '分类2',
  //   submitTime: '2023-01-01',
  //   group: '组2',
  //   isPhysicalObject: '非实物',
  //   status: '待评审'
  // }
]);


const reviewRecords = ref([]);
// 获取评审记录
const getReviewRecords = async (work_id) => {
  try {
    const res = await getReviewRecordsApi({ 
      type: revirwer_type && revirwer_type==='kechuang' ? '1' : '0',
      work_id: work_id,
    });
    if(res.success){
      reviewRecords.value = res.data;
    }
  } catch (error) {
    ElMessage.error('获取评审记录失败: ' + (error.message || '未知错误'));
  }
};


const recordVisible = ref(false);
const viewRecord = (project) => {
  recordVisible.value = true;
  getReviewRecords(project.work_id);
}






const loading = ref(false);
const dialogVisible = ref(false);
const currentProject = ref(null);
const reviewFormRef = ref();

// 评审表单数据
const reviewForm = reactive({
  realScore: 0,
  noveltyScore: 0,
  scienceScore: 0,
  guideScore: 0,
  rigorScore: 0,
  comment: ''
});

// 评审表单验证规则
const reviewRules = {
  realScore: [
    { required: true, message: '请给出评分', trigger: 'change' }
  ],
  noveltyScore: [
    { required: true, message: '请给出评分', trigger: 'change' }
  ],
  scienceScore: [
    { required: true, message: '请给出评分', trigger: 'change' }
  ],
  guideScore: [
    { required: true, message: '请给出评分', trigger: 'change' }
  ],
  rigorScore: [
    { required: true, message: '请给出评分', trigger: 'change' }
  ],
  comment: [
    { required: true, message: '请输入评审意见', trigger: 'blur' },
    { min: 20, message: '评审意见至少 20 个字符', trigger: 'blur' }
  ]
};

const isReviewerList = ref([]);
// 加载待评审项目
const loadPendingProjects = async () => {
  loading.value = true;
  try {
    const data = await request.get('/projects/pending-review');
    pendingProjects.value = data;
  } catch (error) {
    ElMessage.error('加载待评审项目失败: ' + (error.message || '未知错误'));
  } finally {
    loading.value = false;
  }
};



const router = useRouter();
// 处理评审
const handleReview = (project) => {
  // currentProject.value = { ...project };
  // // 重置评审表单
  // reviewForm.realScore = 0;
  // reviewForm.noveltyScore = 0;
  // reviewForm.scienceScore = 0;
  // reviewForm.guideScore = 0;
  // reviewForm.rigorScore = 0;
  // reviewForm.comment = '';
  // if (reviewFormRef.value) {
  //   reviewFormRef.value.resetFields();
  // }
  // dialogVisible.value = true;
  router.push({ name: 'ReviewDetail', query: { id: project.work_id } });
};

// 提交评审
const submitReview = async () => {
  if (!currentProject.value) return;
  
  try {
    // 表单验证
    await reviewFormRef.value.validate();
    
    // 显示加载
    const loading = ElLoading.service({
      lock: true,
      text: '正在提交评审...',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    
    // 提交评审
    await request.post(`/projects/${currentProject.value.id}/review`, {
      rigorScore: reviewForm.rigorScore,
      realScore: reviewForm.realScore,
      noveltyScore: reviewForm.noveltyScore,
      scienceScore: reviewForm.scienceScore,
      guideScore: reviewForm.guideScore,
      comment: reviewForm.comment
    });
    
    // 关闭加载
    loading.close();
    
    ElMessage.success('评审提交成功！');
    
    // 关闭对话框
    dialogVisible.value = false;
    
    // 重新加载待评审项目
    // loadPendingProjects();
    handleSearch()
  } catch (error) {
    // 验证失败不处理
    if (error.name === 'ValidationError') return;
    
    ElMessage.error('提交评审失败: ' + (error.message || '未知错误'));
  }
};

// 下载文件
const downloadFile = async (fileUrl) => {
  if (!fileUrl) return;
  
  try {
    const response = await request.get(fileUrl, {
      responseType: 'blob'
    });
    
    // 创建下载链接
    const url = window.URL.createObjectURL(new Blob([response]));
    const a = document.createElement('a');
    a.href = url;
    
    // 从URL中提取文件名
    const fileName = fileUrl.split('/').pop();
    a.download = fileName;
    
    document.body.appendChild(a);
    a.click();
    
    // 清理
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  } catch (error) {
    ElMessage.error('下载失败: ' + (error.message || '未知错误'));
  }
};

const activities = ref([])

const activity_id = ref('')
const review_round = ref('')

const handleSearch = () => {
  getReviewWorkList(
    // {
    //   page: 1,
    //   per_page: 99999,
    //   activity_id: activity_id.value,
    //   review_round: review_round.value
    // }
).then(res => {
    console.log('获取评审作品列表', res)
    pendingProjects.value = res.data.works
    isReviewerList.value = res.data.works.map(item => ({
      work_id: item.work_id,
      isReviewer: false
    }));
    console.log('isReviewerList:',isReviewerList.value);
  })
}
const workStatusOptions = ref([])

// 组件挂载时加载数据
onMounted(()=>{
  // loadPendingProjects();
  // getReviewTaskList({
  //   page: 1,
  //   page_size: 10
  // }).then(res => {
  //   console.log('获取评审任务列表', res)
  // })

  handleSearch()

  getActivityListApi({  
    title: '',
    page: 1,
    per_page: 99999,
    activity_type: null,
    activity_status: null,
    region: ''
  }).then(res => {
    // console.log('获取活动列表', res)
    activities.value = res.data.activities.map(item => ({
      activity_id: item.activity_id,
      title: item.title
    }))
    console.log('活动ID列表', activities.value)
  })

  getDictList('submit_status').then(res => {
    workStatusOptions.value = res.data.items
    console.log('workStatusOptions', workStatusOptions.value)
  })

});


</script>

<template>
  <div>
    <div class="review-container">
    <h2>待评审作品</h2>
    <!-- <div class="search-container"> -->
      <!-- <el-input
        v-model="input2"
        class="responsive-input"
        placeholder="搜索活动名称..."
        :prefix-icon="Search"
      /> -->
      <!-- <el-select
        v-model="review_round"
        placeholder="选择评审轮次"
        clearable
      >
        <el-option label="一轮评审" value="1" />
        <el-option label="二轮评审" value="2" />
      </el-select>
      <el-select
        v-model="activity_id"
        placeholder="选择活动"
        clearable
      >
        <el-option v-for="item in activities"
          :key="item.activity_id"
          :label="item.title"
          :value="item.activity_id" />
      </el-select>
      <el-button type="primary" @click="handleSearch">搜索</el-button> -->
    <!-- </div> -->

      <el-table :data="pendingProjects" 
        stripe border style="width: 100%;margin-top: 20px;"
        v-loading="loading"
      >
        <el-table-column prop="title" label="作品名称"></el-table-column>
        <el-table-column prop="activity_name" label="归属活动"></el-table-column>
        <el-table-column prop="contestant_name" label="作者"></el-table-column>
        <!-- <el-table-column prop="category" label="作品类别"></el-table-column>
        <el-table-column prop="isPhysicalObject" label="作品形式"></el-table-column>
        <el-table-column prop="group" label="作品组别"></el-table-column> -->
        <el-table-column prop="created_at" label="提交时间"></el-table-column>
        <el-table-column prop="submit_status" label="状态">
          <template #default="scope">
          <el-tag effect="dark"
            :color="workStatusOptions.find(item => item.id === scope.row.submit_status)?.color"
            size="small"
          >
            {{ workStatusOptions.find(item => item.id === scope.row.submit_status)?.name || scope.row.submit_status }}
          </el-tag>
        </template>
        </el-table-column>
        <el-table-column label="操作" width="300">
          <template #default="scope">

            <el-button type="primary" size="small" plain @click="viewRecord(scope.row)">
              评审记录
            </el-button>
            <!-- v-if="!isReviewerList.find(item => item.work_id === scope.row.work_id)?.isReviewer" -->
            <el-button type="primary" size="small" 
              @click="handleReview(scope.row)" :disabled="scope.row.submit_status === 5 || scope.row.submit_status === 6">
              评审
              <!-- {{ isReviewerList.find(item => item.work_id === scope.row.work_id)?.isReviewer ? '已评审' : '未评审' }} -->
            </el-button>
          </template>
        </el-table-column>
      </el-table>


      <el-dialog 
        title="评审记录" 
        :model-value="recordVisible"
        :width="'60%'"
        @update:model-value="(visible) => recordVisible = visible"
      >
        <el-table :data="reviewRecords" stripe border style="width: 100%;margin-top: 20px;">
          <el-table-column prop="reviewer_name" label="评审人"></el-table-column>
          <el-table-column prop="score" label="评审分数">
            <template #default="scope">
              {{ scope.row.score? scope.row.score : '0' }}
            </template>
          </el-table-column>
          <el-table-column prop="comments" label="评审意见">
            <template #default="scope">
              {{ scope.row.comments || '无' }}
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
      <!-- 评审对话框 -->
      <el-dialog 
        title="评审作品" 
        :model-value="dialogVisible"
        :width="'60%'"
        @update:model-value="(visible) => dialogVisible = visible"
      >
        <div v-if="currentProject" class="review-form">
          <h3>{{ currentProject.projectName }}</h3>
          <p><strong>作者：</strong>{{ currentProject.author }}</p>
          <p><strong>提交时间：</strong>{{ currentProject.submitTime }}</p>
          <p><strong>作品描述：</strong>{{ currentProject.description }}</p>
          
          <div class="file-download">
            <el-button 
              type="text" 
              @click="downloadFile(currentProject.fileUrl)"
              v-if="currentProject.fileUrl"
            >
              <i class="fas fa-download"></i> 下载作品文件
            </el-button>
          </div>
          
          <el-form 
            :model="reviewForm" 
            :rules="reviewRules" 
            ref="reviewFormRef"
            label-width="200px"
            label-suffix="："
            class="internal-review-form"
          >
            <el-form-item label="创意的真实性" prop="realScore">
              <el-input-number v-model="reviewForm.realScore" :min="0" :max="20" @change="handleChange" />
            </el-form-item>
            <el-form-item label="创意的新颖性" prop="noveltyScore">
              <el-input-number v-model="reviewForm.noveltyScore" :min="0" :max="20" @change="handleChange" />
            </el-form-item>
            <el-form-item label="创意的科学性" prop="scienceScore">
              <el-input-number v-model="reviewForm.scienceScore" :min="0" :max="20" @change="handleChange" />
            </el-form-item>
            <el-form-item label="激发引导作用" prop="guideScore">
              <el-input-number v-model="reviewForm.guideScore" :min="0" :max="20" @change="handleChange" />
            </el-form-item>
            <el-form-item label="表达的严谨性" prop="rigorScore">
              <el-input-number v-model="reviewForm.rigorScore" :min="0" :max="20" @change="handleChange" />
            </el-form-item>
            
            <el-form-item label="评审意见" prop="comment">
              <el-input 
                v-model="reviewForm.comment" 
                type="textarea" 
                rows="6"
                placeholder="请输入评审意见..."
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        
        <template #footer>
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button 
            type="primary" 
            @click="submitReview"
          >
            提交评审
          </el-button>
        </template>
      </el-dialog>
    </div>
  </div>
  
</template>


<style scoped>
.review-container {
  padding: 20px;
}


.search-container {
  margin: 20px auto;
  display: grid;
  grid-template-columns: 1fr 1fr auto 2fr;
  gap: 20px;
}

.review-form {
  margin-top: 15px;
  line-height: 1.8;
}

.file-download {
  margin: 15px 0;
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.internal-review-form {
  margin-top: 20px;
}

.el-tag {
  border-width: 0px;
}
</style>